import { Injectable } from '@angular/core';
import { Observable} from 'rxjs/internal/Observable';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { AuthService } from './services/auth.service';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AssessmentAttempterService {

  constructor(private http: HttpClient, private authService: AuthService) { }

  attempterUrl = environment.questions.apiUrl;

  startAssessment(assessmentId:string, userId:string){
    let body = {
      "flow_selected":"start-assessemnt",
      "userId":userId,
      "assessmentId":assessmentId
    };
    return this.http.post(this.attempterUrl, JSON.stringify(body));
  }

  pursueAssessment(assessmentObj:any){
    let body = {
      "flow_selected":"pursue-session",
      ...assessmentObj
    }
    return this.http.post(this.attempterUrl, JSON.stringify(body));
  }

  failAssessmentAttempt(
    userId: string,
    sessionId: string,
    reason: 'TAB_HIDDEN' | 'CAMERA_STOPPED'
  ): boolean {
    const body = JSON.stringify({
      flow_selected: 'fail-assessment-attempt',
      userId,
      sessionId,
      reason,
      clientDetectedAt: new Date().toISOString()
    });
    const token = this.authService.getIdToken();
    if (!token) return false;

    // sendBeacon cannot set Authorization. An authenticated keepalive request
    // still has a chance to finish while the browser is hiding the document.
    void this.sendAuthenticatedKeepalive(body, token).then(async (response) => {
      if (response.status === 401) {
        const refreshedToken = await this.authService.refreshSession();
        await this.sendAuthenticatedKeepalive(body, refreshedToken);
      }
    }).catch(() => {});
    return true;
  }

  private sendAuthenticatedKeepalive(body: string, token: string): Promise<Response> {
    return fetch(this.attempterUrl, {
      method: 'POST',
      body,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      keepalive: true,
      mode: 'cors'
    });
  }

  private _rulesObject = new BehaviorSubject<string>("");
  $rulesObject = this._rulesObject.asObservable();

  publishRulesObject(rulesObject: string){
    this._rulesObject.next(rulesObject);
  }

  private _questionObject = new BehaviorSubject<string>("");
  $questionObject = this._questionObject.asObservable();

  publishQuestionObject(questionObject: string){
    this._questionObject.next(questionObject);
  }

  // relay selected options
  private _selectedOptionsObject = new BehaviorSubject<string>("");
  $selectedOptionObject = this._selectedOptionsObject.asObservable();

  publishSelectOptions(selectedOptions: string){
    this._selectedOptionsObject.next(selectedOptions);
  }

  /** Synchronous snapshot of the latest selected options value */
  getSelectedOptionsSnapshot(): string {
    return this._selectedOptionsObject.getValue();
  }

}
